(function ($) {
  function setHeight(){
      $('.blog-post .blog-card .title').matchHeight();
      $('.related-blogs .media-content .title').matchHeight();
  }
  var doit;
  window.onresize = function(){
      clearTimeout(doit);
      doit = setTimeout(setHeight, 100);
  };
  $(document).ready(function() {
      $('.blog-post .blog-card .title').matchHeight();
      $('.related-blogs .media-content .title').matchHeight();  	
  });

  $(function($) {
    let url = window.location.href;
    $('.blog__filter .tag-filter a').each(function() {
      if (this.href == url) {
        $(this).closest('a').addClass('active');
      }
    });
  });
})(jQuery);

